import { supabase } from '../SupabaseClient/supabase-client'
import type { StockAnalysisData } from '@/types/StockAnalysis'

const FUNCTION_NAME = 'stock-analysis'

export const stockAnalysisService = {
  async getByTicker(ticker: string): Promise<StockAnalysisData> {
    const { data, error } = await supabase.functions.invoke(`${FUNCTION_NAME}?ticker=${ticker}`, { method: 'GET' })
    if (error) throw error
    return data as StockAnalysisData
  },
}
